import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Title from '@components/Title';
import ProductItemPrice from '@components/ProductItemPrice';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';

const Container = styled.div`
  margin: ${({ theme }) => theme.commons.header.margin};
  padding: ${({ theme }) => theme.commons.header.padding};
  background: ${({ theme }) => theme.commons.header.background};
  box-shadow: ${({ theme }) => theme.commons.header.elevation};
  ${({ rowableContent }) =>
    rowableContent &&
    css`
      display: flex;
      align-items: center;
      justify-content: space-between;
    `}
`;

const Description = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular}
  text-align: left;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-top: ${({ withMargin }) => (withMargin ? '10px' : '0')};
`;

const StyledProductItemPrice = styled(ProductItemPrice)`
  ${({ theme }) => theme.fontFamily.secondaryFont.largeBold}

  margin-top: 8px;
`;

const ProductItemNoPrice = styled.div`
  height: 69px;
`;

const TextContainer = styled.div`
  width: 80%;
`;

function HeaderDescription({
  description,
  name,
  price,
  priceWithDiscount,
  subsidizedProduct,
  discount,
  finalPriceWithoutTaxes,
}) {
  const isDesktopLayout = useIsDesktopLayout();
  return (
    <Container rowableContent={isDesktopLayout}>
      <TextContainer>
        {name && <Title label={name} />}
        {!!description && (
          <Description withMargin={!isDesktopLayout}>{description}</Description>
        )}
      </TextContainer>

      {price ? (
        <div>
          <StyledProductItemPrice
            price={price}
            priceWithDiscount={priceWithDiscount}
            subsidizedProduct={subsidizedProduct}
            discount={discount > 0}
            finalPriceWithoutTaxes={null}
          />
          <StyledProductItemPrice
            price={null}
            finalPriceWithoutTaxes={finalPriceWithoutTaxes}
          />
        </div>
      ) : (
        <ProductItemNoPrice />
      )}
    </Container>
  );
}

HeaderDescription.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  price: PropTypes.number,
  priceWithDiscount: PropTypes.number,
  subsidizedProduct: PropTypes.object,
  discount: PropTypes.number,
  finalPriceWithoutTaxes: PropTypes.number,
};

export default HeaderDescription;
